import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogService } from '../../services/dialog.service';

@Component({
  selector: 'icc-list',
  templateUrl: './icc-list.component.html',
  styleUrls: ['./icc-list.component.less'],
})
export class IccListComponent implements OnInit {
  constructor(private dialogService: DialogService, private cdr: ChangeDetectorRef) {}
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() remove: EventEmitter<any> = new EventEmitter<any>();
  @Input() width = 450;
  @Input() title = '编辑列表选项';
  @Input() description = '添加和组织标签列表选项，列表中的标签名称不能重名。';
  @Input() list: Array<{
    name: string;
    checked?: boolean;
  }>;
  @Input() maxLength = 20;
  // 输入框文字最大长度
  @Input() textMaxLength = 1000;

  // 显隐modal
  isVisible: boolean;
  // 修改项的下标
  editIndex: number;
  // 选中项的下标
  selectedIndex: number;
  // 初始值是否有选中值
  hasChecked: boolean;
  // 是否存在复选功能
  @Input() showCheckedBox: boolean;
  // 名称后缀
  suffix = 0;
  // 同名警告
  hasWarning: boolean;
  temp: any;

  ngOnInit() {
    this.hasChecked = this.isExistChecked();
  }
  displayModel(isShow: boolean) {
    this.isVisible = isShow;
    if (this.isVisible && this.list && this.list.length) {
      const len = this.list.length - 1;
      this.editIndex = len;
      this.selectedIndex = len;
    }
  }
  toggleDom(evt: any, idx: number) {
    console.log('点击了这个标签');
    if (this.editIndex !== -1 && this.findExistName(this.list[this.editIndex].name).length > 1) {
      this.hasWarning = true;
      return false;
    }
    this.hasWarning = false;
    if (idx !== this.editIndex) {
      this.editIndex = idx;
    }
    const inputEl = evt.target.nextElementSibling;
    const timeout = setTimeout(() => {
      if (inputEl && inputEl.focus) {
        inputEl.select();
        inputEl.focus();
      }
      clearTimeout(timeout);
    }, 0);
  }
  changeSelected(evt: any, idx: number) {
    if (this.editIndex !== -1 && this.findExistName(this.list[this.editIndex].name).length > 1) {
      this.hasWarning = true;
      return false;
    }
    this.hasWarning = false;
    const classList = evt.target.classList.toString();
    if (classList.indexOf('item ') !== -1 && classList.indexOf('selected') === -1) {
      this.editIndex = -1;
    }
    if (idx !== this.selectedIndex) {
      this.selectedIndex = idx;
    }
  }
  addItem(evt) {
    if (evt && 13 === evt.keyCode) {
      if (this.editIndex !== -1 && this.findExistName(this.list[this.editIndex].name).length > 1) {
        this.hasWarning = true;
        return false;
      }
      this.handleClick(evt, 'add');
    } else {
      setTimeout(() => {
        this.hasWarning = this.findExistName(this.list[this.editIndex].name).length > 1;
        if (this.hasWarning) {
          // 提示部分
          this.dialogService.notification.warning('标签', '同一标签类下标签值不能相同');
        }
      }, 0);
    }
  }
  handleClick(evt, operateName) {
    let name;
    if (operateName) {
      name = operateName;
    } else {
      name = evt.target.getAttribute('name');
    }
    const scrollEl = document.getElementById('scroll-box-id');
    switch (name) {
      case 'add':
        if (this.hasWarning) {
          // 提示部分
          this.dialogService.notification.warning('标签', '同一标签类下标签值不能相同');
          return;
        }
        if (this.list.length >= this.maxLength) {
          // 提示部分
          this.dialogService.notification.error('标签', '最多添加20个标签项');
          return;
        }
        const newItem: any = { name: this.getNewItemName() };
        if (this.showCheckedBox) {
          newItem.checked = true;
        }
        this.list.push(newItem);
        this.editIndex = this.list.length - 1;
        this.selectedIndex = this.editIndex;
        this.hasChecked = true;
        this.cdr.detectChanges();
        const timeout = setTimeout(() => {
          const children = document.getElementById('scroll-box-id').children;
          children[children.length - 1].scrollIntoView();
          const inputEl: any = children[children.length - 1].getElementsByClassName('item-input')[0];
          inputEl.select();
          inputEl.focus();
          clearTimeout(timeout);
        }, 0);
        break;
      case 'up':
        if (this.selectedIndex > this.list.length - 1 || !this.list.length || this.selectedIndex === 0) {
          return false;
        }
        const selectItem1 = this.list.splice(this.selectedIndex, 1)[0];
        this.list.splice(this.selectedIndex - 1, 0, selectItem1);
        this.selectedIndex--;
        if (this.selectedIndex + 1 === this.editIndex) {
          this.editIndex--;
        }
        const selectedList1 = scrollEl.getElementsByClassName('selected');
        if (selectedList1 && selectedList1[0]) {
          selectedList1[0].scrollIntoView(false);
        }
        break;
      case 'down':
        if (this.selectedIndex > this.list.length - 1 || !this.list.length || this.selectedIndex === this.list.length - 1) {
          return false;
        }
        const selectItem2 = this.list.splice(this.selectedIndex, 1)[0];
        this.list.splice(this.selectedIndex + 1, 0, selectItem2);
        this.selectedIndex++;
        if (this.selectedIndex - 1 === this.editIndex) {
          this.editIndex++;
        }
        const selectedList2 = scrollEl.getElementsByClassName('selected');
        if (selectedList2 && selectedList2[0]) {
          selectedList2[0].scrollIntoView(true);
        }
        break;
      case 'close':
        this.remove.emit(() => {
          if (this.showCheckedBox) {
            if (!this.hasChecked) {
              return false;
            }
            const indexArray = [];
            for (let i = this.list.length - 1; i >= 0; i--) {
              if (this.list[i].checked) {
                this.list.splice(i, 1);
                indexArray.push(i);
              }
            }
            if (indexArray.indexOf(this.editIndex) !== -1) {
              this.editIndex = -1;
            }
            if (indexArray.indexOf(this.selectedIndex) !== -1) {
              this.selectedIndex = -1;
            }
          } else {
            this.list.splice(this.selectedIndex, 1);
            this.selectedIndex = -1;
            this.editIndex = -1;
          }
        });
        break;
      default:
        break;
    }
  }
  checkedChange(flag: boolean) {
    if (!flag) {
      this.hasChecked = this.isExistChecked();
    } else {
      this.hasChecked = true;
    }
  }
  btnOk() {
    let selectedList;
    if (this.showCheckedBox) {
      selectedList = [];
      this.list.forEach(item => {
        if (item.checked) {
          selectedList.push(item);
        }
      });
    } else {
      selectedList = this.list;
    }
    this.change.emit(selectedList);
    this.displayModel(false);
  }
  getNewItemName() {
    const newName = 'example' + (this.suffix ? this.suffix : '');
    this.suffix++;
    if (this.findExistName(newName).length > 0) {
      return this.getNewItemName();
    } else {
      return newName;
    }
  }
  isExistChecked() {
    return this.list.filter(item => item.checked === true).length ? true : false;
  }
  findExistName(name) {
    return this.list.filter(item => item.name === name);
  }

  /** 失去焦点 */
  onblurHandle(ev, index) {
    if (!ev.target.value) {
      console.log(123123213);
      this.list.splice(index, 1);
      this.editIndex = this.list.length - 1;
    }
  }
}
